import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import styles from "./Auth.module.css";
import buttonStyles from "../styles/Buttons.module.css";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Spinner from "../components/Spinner";

export default function Register() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [acceptedAll, setAcceptedAll] = useState(false);
  const [passError, setPassError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();

  const isPassStrong = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(pass);

  const submit = async e => {
    e.preventDefault();

    if (!acceptedAll) {
      setShowModal(true);
      return;
    }

    if (!isPassStrong) {
      setPassError(true);
      return;
    }
    try {
      setLoading(true);
      await register(email.trim(), pass);
      navigate(`/verify-email?email=${encodeURIComponent(email.trim())}`);
    } catch (error) {
      alert("Error al crear la cuenta: " + error.message);
    } finally {
      setLoading(false);
    }

  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h2 className={styles.title}>Regístrate</h2>
        <form onSubmit={submit} className={styles.form}>
          <div className={styles.inputWrapper}>
            <FaEnvelope className={styles.icon} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className={styles.input}
              autoComplete="email"
            />
          </div>

          <div className={styles.inputWrapper}>
            <FaLock className={styles.icon} />
            <input
              type={showPass ? "text" : "password"}
              placeholder="Contraseña"
              value={pass}
              onChange={e => {
                setPass(e.target.value);
                setPassError(false); // Oculta el error al escribir
              }}
              required
              className={styles.input}
              autoComplete="new-password"
            />
            <span
              className={styles.toggleIcon}
              onClick={() => setShowPass(!showPass)}
              role="button"
              aria-label={showPass ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              {showPass ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>

          {/* Mensaje de validación */}
          {pass && passError && (
            <p className={styles.error}>
              La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número.
            </p>
          )}

          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={acceptedAll}
              onChange={e => setAcceptedAll(e.target.checked)}
            />
            Acepto los{" "}
            <Link to="/terminos" target="_blank" rel="noopener noreferrer">
              Términos y Condiciones
            </Link>{" "}
            y la{" "}
            <Link to="/privacidad" target="_blank" rel="noopener noreferrer">
              Política de Privacidad
            </Link>.
          </label>

          <button type="submit" className={buttonStyles.btnPrimary} disabled={loading}>
            {loading ? <Spinner size={18} /> : "Crear cuenta"}
          </button>
        </form>

        <p className={styles.footerText}>
          ¿Ya tienes cuenta?{" "}
          <Link to="/login" className={styles.link}>
            Inicia sesión
          </Link>
        </p>
      </div>

      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h3>⚠️ Aviso importante</h3>
            <p>Debes aceptar los Términos y Condiciones y la Política de Privacidad para continuar.</p>
            <button
              onClick={() => setShowModal(false)}
              className={buttonStyles.btnSecondary}
            >
              Entendido
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
